(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("redux-dynamic-modules-core"), require("redux-saga"));
	else if(typeof define === 'function' && define.amd)
		define(["redux-dynamic-modules-core", "redux-saga"], factory);
	else if(typeof exports === 'object')
		exports["redux-dynamic-modules-saga"] = factory(require("redux-dynamic-modules-core"), require("redux-saga"));
	else
		root["redux-dynamic-modules-saga"] = factory(root["redux-dynamic-modules-core"], root["redux-saga"]);
})(window, function(__WEBPACK_EXTERNAL_MODULE_redux_dynamic_modules_core__, __WEBPACK_EXTERNAL_MODULE_redux_saga__) {
return 